interface ImageProps {
  iconPath: string;
  style?: React.CSSProperties;
  styleImage?: React.CSSProperties;
}

const LabelIcon = ({ iconPath, style, styleImage }: ImageProps) => (
  <img className="base-label-icon" style={styleImage} src={require(`../../../Assets/images/icons_labels/${iconPath}`)} alt="" />
);

export default LabelIcon;
